// extracted by mini-css-extract-plugin
export default {"todo":"todo_todo__WVv-F","btn":"todo_btn__MwYCg"};